import { render, staticRenderFns } from "./marketingPostersList.vue?vue&type=template&id=29d9d6c5&scoped=true&"
import script from "./marketingPostersList.vue?vue&type=script&lang=js&"
export * from "./marketingPostersList.vue?vue&type=script&lang=js&"
import style0 from "./marketingPostersList.vue?vue&type=style&index=0&id=29d9d6c5&prod&scoped=true&lang=scss&"
import style1 from "./marketingPostersList.vue?vue&type=style&index=1&id=29d9d6c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d9d6c5",
  null
  
)

export default component.exports